import imageLazy from './image-lazy/image-lazy'

imageLazy.init()
